import React, { useState, useRef, useEffect, useMemo } from "react";
import "./SponsorCard.css";
import { useTranslation } from "react-i18next";

import emslimImage from "../../../../assets/images/steri1.jpeg";
import skincareImage from "../../../../assets/images/steri2.jpeg";
import healthcareImage from "../../../../assets/images/produit3.png";

const SponsorCard = () => {
  const { t } = useTranslation();

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const slides = useMemo(
    () => [
      {
        image: emslimImage,
        title: t("sponsor.slides.sterilizer.title"),
        description: t("sponsor.slides.sterilizer.desc"),
      },
      {
        image: skincareImage,
        title: t("sponsor.slides.sterilizer.title"),
        description: t("sponsor.slides.sterilizer.desc"),
      },
      {
        image: healthcareImage,
        title: t("sponsor.slides.skincare.title"),
        description: t("sponsor.slides.skincare.desc"),
      },
    ],
    [t]
  );

  const [index, setIndex] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const containerRef = useRef(null);

  // Auto-rotation every 3s
  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, 3000);
    return () => clearInterval(id);
  }, [slides.length]);

  const handleViewAll = () => {
  };

  // Drag souris
  const handleMouseDown = (e) => {
    if (!containerRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !containerRef.current) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const stopDrag = () => setIsDragging(false);

  // Touch mobile
  const handleTouchStart = (e) => {
    if (!containerRef.current) return;
    setIsDragging(true);
    setStartX(e.touches[0].pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleTouchMove = (e) => {
    if (!isDragging || !containerRef.current) return;
    const x = e.touches[0].pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div
      className={`ad-banner-container ${isDragging ? "dragging" : ""}`}
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={stopDrag}
      onMouseLeave={stopDrag}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={stopDrag}
    >
      {/* Slide image */}
      <img
        key={`img-${index}`}
        src={slides[index].image}
        alt={slides[index].title}
        className="ad-image fade"
        draggable={false}
      />

      {/* Slide content */}
      <div key={`content-${index}`} className="ad-content fade">
        <h1 className="main-title">{slides[index].title}</h1>

        <div className="description-container">
          <p className="main-description">{slides[index].description}</p>
        </div>

       
      </div>
    </div>
  );
};

export default SponsorCard;
